module.exports = "/static-assets/_next/static/images/victorian-e37c1337b8f6d73af4be92f04ca760be.png";